// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.y_OgAmWNzofLG3Df {
	font: var(--lok-typography-body-small-strong);
	font-family: var(--lok-font-family-inter);
}

.pvLEni_cgMJHba1c.pvLEni_cgMJHba1c {
	max-width: 370px;
	text-align: center;
	font-family: var(--lok-font-family-inter);
}
`, "",{"version":3,"sources":["webpack://./packages/rag/src/components/Cards/components/CardTitle/CardTitle.module.css"],"names":[],"mappings":"AAAA;CACC,6CAA6C;CAC7C,yCAAyC;AAC1C;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;CAClB,yCAAyC;AAC1C","sourcesContent":[".title {\n\tfont: var(--lok-typography-body-small-strong);\n\tfont-family: var(--lok-font-family-inter);\n}\n\n.tooltip.tooltip {\n\tmax-width: 370px;\n\ttext-align: center;\n\tfont-family: var(--lok-font-family-inter);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `y_OgAmWNzofLG3Df`,
	"tooltip": `pvLEni_cgMJHba1c`
};
export default ___CSS_LOADER_EXPORT___;
